// extracted by mini-css-extract-plugin
export default {"google":"google__ZEQ7X","background":"background__6hcm9","login-with-google-btn":"login-with-google-btn__KkpiO"};